<template>
  <div>

    <Card>
      <Form @keydown.native.enter.prevent="addTask" :label-width="100" :model="formData">
        <Row :gutter="16">
          <Col span="6">
            <FormItem label="省份：" prop="province">
              <Select v-model="formData.province" placeholder="请选择省份" @on-change="changeProvince">
                <Option value="">请选择</Option>
                <Option v-for="(item,key) in provinces" :value="item" :key="key">{{item}}</Option>
              </Select>
            </FormItem>
          </Col>

          <Col span="6">
            <FormItem label="城市：" prop="city">
              <Select v-model="formData.city" placeholder="请选择城市" @on-change="changeCity">
                <Option value="">请选择</Option>
                <Option v-for="(item,key) in citys" :value="item" :key="key">{{item}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="站点类型：" prop="station_type">
              <Select v-model="formData.station_type" placeholder="请选择站点类型">
                <Option value="">全部</Option>
                <Option value="oil_station">柴油站点</Option>
                <Option value="lng_station">LNG气站</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="时间：" prop="do_time">
              <DatePicker v-model="formData.do_time" type="datetime" placeholder="选择执行时间" style="width: 100%"></DatePicker>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col span="6">
            <FormItem label="挂牌价：" prop="ndrc_price">
              <Input v-model="formData.ndrc_price" placeholder="请输入挂牌价">
                <template #append>元</template>
              </Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="油机价：" prop="station_price">
              <Input v-model="formData.station_price" placeholder="请输入油机价">
                <template #append>元</template>
              </Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="结算价：" prop="settlement_price">
              <Input v-model="formData.settlement_price" placeholder="请输入结算价">
                <template #append>元</template>
              </Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form-item>
              <Button type="primary" @click="addTask" icon="md-checkmark">确定添加</Button>
              <Button type="success" @click="showStationSelectModal" style="margin-left: 10px" icon="md-settings">批量设置站点价格</Button>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </Card>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="{}"
               :showSearchForm="false"
               tableApi="admin/ndrc_price/getTasks"
    >

     <!-- <template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="exportData">导出</Button>
        </FormItem>
      </template>-->
    </pageTable>

    <!-- 批量设置站点价格弹窗 -->
    <Modal
      v-model="stationSelectModal.visible"
      title="批量设置站点价格"
      width="900"
      @on-ok="submitStationPrice"
      @on-cancel="cancelStationSelect"
    >
      <Form :label-width="100">
        <Row :gutter="16">
          <Col span="12">
            <div style="padding: 10px; background: #f8f8f9; border-radius: 4px;">
              <p style="margin: 0 0 8px 0; font-weight: bold;">当前设置信息：</p>
              <p style="margin: 4px 0; color: #666;">省份：{{ formData.province || '未选择' }}</p>
              <p style="margin: 4px 0; color: #666;">城市：{{ formData.city || '未选择' }}</p>
              <p style="margin: 4px 0; color: #666;">油机价：{{ formData.station_price || '未设置' }} 元</p>
              <p style="margin: 4px 0; color: #666;">挂牌价：{{ formData.ndrc_price || '未设置' }} 元</p>
              <p style="margin: 4px 0; color: #666;">结算价：{{ formData.settlement_price || '未设置' }} 元</p>
              <p style="margin: 4px 0; color: #666;">执行时间：{{ formData.do_time || '未设置' }}</p>
            </div>
          </Col>
        </Row>
        <FormItem label="选择站点：" style="margin-top: 16px;">
          <div style="margin-bottom: 10px; color: #999; font-size: 12px;">
            共 {{ stationSelectModal.allStationList.length }} 个站点，已筛选 {{ stationSelectModal.stationList.length }} 个，已选择 {{ stationSelectModal.selectedStations.length }} 个
          </div>
          <div style="margin-bottom: 10px;">
            <Button size="small" @click="selectAllStations">全选</Button>
            <Button size="small" @click="clearAllStations" style="margin-left: 8px;">清空</Button>
          </div>
          <div style="max-height: 400px; overflow-y: auto; border: 1px solid #dcdee2; padding: 10px; border-radius: 4px;">
            <CheckboxGroup v-model="stationSelectModal.selectedStations">
              <div v-for="station in stationSelectModal.stationList" :key="station.station_id" 
                   style="margin-bottom: 8px; padding: 5px; border-bottom: 1px solid #f0f0f0;">
                <Checkbox :label="station.station_id">
                  <span style="margin-left: 8px;">{{ station.gas_name }}</span>
                  <Tag size="default" style="margin-left: 8px;">ID: {{ station.station_id }}</Tag>
                  <Tag size="default" color="blue" style="margin-left: 4px;">{{ station.province_name }} {{ station.city_name }}</Tag>
                </Checkbox>
              </div>
            </CheckboxGroup>
            <div v-if="stationSelectModal.stationList.length === 0" style="text-align: center; color: #999; padding: 20px;">
              暂无站点数据
            </div>
          </div>
        </FormItem>
      </Form>
    </Modal>

    <!-- 查看已选择站点弹窗 -->
    <Modal
      v-model="selectedStationsModal.visible"
      title="已选择的站点列表"
      width="900"
      @on-cancel="cancelSelectedStationsView"
    >
      <div>
        <div style="margin-bottom: 10px; color: #666;">
          共 {{ selectedStationsModal.stationList.length }} 个站点
        </div>
        <div style="max-height: 500px; overflow-y: auto;">
          <Table :columns="selectedStationsColumns" :data="selectedStationsModal.stationList" border stripe></Table>
          <div v-if="selectedStationsModal.stationList.length === 0" style="text-align: center; color: #999; padding: 40px;">
            暂无站点数据
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
  import config from '@/config/base-config'
  import pageTable from "@/components/table/pageTable";
  export default {
    name: "edit",
    components:{pageTable},
    data(){
      return {
        formData:{
          province:'',
          city:'',
          county:'',
          station_type:'', // 油站类型：oil_station-柴油站点, lng_station-LNG气站
          ndrc_price:'',
          station_price:'',
          settlement_price:'',
          do_time:'',
          station_ids: [], // 选中的站点ID数组
        },
        province_county_data:[],    //省市区数据
        provinces:[],
        citys:[],
        countys:[],
        tableColumn: [
          {title: '省',key: 'province_name',align: "center"},
          {title: '市',key: 'city_name',align: "center"},
          {title: '油机价',key: 'station_price',align: "center", render: (h, params) => {
            return h('span', params.row.station_price ? `¥${params.row.station_price}` : '-');
          }},
          {title: '挂牌价',key: 'ndrc_price',align: "center"},
          {title: '结算价',key: 'settlement_price',align: "center", render: (h, params) => {
            return h('span', params.row.settlement_price ? `¥${params.row.settlement_price}` : '-');
          }},
          {title: '执行时间',key: 'do_time',align: "center"},
          {title: '状态',key: 'status_name',align: "center"},
          {title: '已选择的站点',key: 'station_count',align: "center", render: (h, params) => {
            // station_ids 可能是字符串（如 "197943,197942"）或数组
            let count = 0;
            if (params.row.station_ids) {
              if (typeof params.row.station_ids === 'string') {
                // 如果是字符串，按逗号分割后统计
                count = params.row.station_ids.split(',').filter(id => id.trim()).length;
              } else if (Array.isArray(params.row.station_ids)) {
                // 如果是数组，直接获取长度
                count = params.row.station_ids.length;
              }
            }
            
            if (count === 0) {
              return h('span', '未选择');
            }
            return h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              on: {
                click: () => {
                  this.showSelectedStations(params.row);
                }
              }
            }, `查看 ${count} 个站点`);
          }},
          {title: '操作',render:(h,params)=>{
              return h('Button',{props:{type:'error',size:'small'},on:{click:()=>{this.delTask(params.row.id)}}},'删除')
            }},
        ],
        tableData: [],
        // 批量设置站点价格弹窗数据
        stationSelectModal: {
          visible: false,
          loading: false,
          station_price: '',
          ndrc_price: '',
          settlement_price: '',
          do_time: '',
          selectedStations: [],
          stationList: [],
          allStationList: [], // 所有站点原始数据
          filterProvince: '',
          filterCity: '',
          provinces: [],
          citys: []
        },
        // 查看已选择站点弹窗数据
        selectedStationsModal: {
          visible: false,
          stationList: [],
          currentRow: null
        },
        // 已选择站点列表的列定义
        selectedStationsColumns: [
          {title: '站点ID', key: 'station_id', align: 'center', width: 100},
          {title: '站点名称', key: 'gas_name', align: 'center'},
          {title: '省份', key: 'province_name', align: 'center', width: 100},
          {title: '城市', key: 'city_name', align: 'center', width: 100},
          {title: '区县', key: 'county_name', align: 'center', width: 100}
        ],
      }
    },
    methods:{
      async getInfo(){

      },
      init(){
        //this.$commonFun.postProxy('admin/tuanyou/getProvince',{}).then((res)=>{
        this.$commonFun.postProxy('admin/gas/getPlatformRegionList',{}).then((res)=>{
          this.province_county_data = res.data.province_county_data;
          this.provinces = res.data.province_data
        })
      },
      async addTask(){
        let res = await this.$commonFun.postProxy('admin/ndrc_price/addTask',{
          ...this.formData,
          station_ids: this.formData.station_ids || []
        })
        this.$commonFun.dealApiResult(res,()=>{
          this.$refs.table.getLists();
          // 清空站点选择
          this.formData.station_ids = [];
        })
        // this.getInfo()
      },
      changeProvince(province){
        this.citys = []
        this.province_county_data.forEach((item,key)=>{
          if (item.value === province){
            item.children.forEach(val=>{
              this.citys.push(val.value)
            })
          }
        })
      },
      changeCity(city){
        this.countys=[]
        let province = this.formData.province
        this.province_county_data.forEach((item,key)=>{
          if (item.value === province){
            item.children.forEach((val)=>{
              if (val.value === city){
                val.children.forEach(val=>{
                  this.countys.push(val.value)
                })
              }
            })

          }
        })
      },
      async delTask(id){
        let res = await this.$commonFun.postProxy('admin/ndrc_price/delTask',{id})
        this.$commonFun.dealApiResult(res,()=>{
          this.$refs.table.getLists();
        })
      },
      // 显示站点选择弹窗
      async showStationSelectModal(){
        // 验证表单数据
        if (!this.formData.station_price && !this.formData.ndrc_price && !this.formData.settlement_price) {
          this.$Message.warning('请至少输入一个价格（油机价、挂牌价或结算价）');
          return;
        }
        if (!this.formData.do_time) {
          this.$Message.warning('请选择执行时间');
          return;
        }
        
        this.stationSelectModal.visible = true;
        this.stationSelectModal.stationList = []; // 先清空
        this.stationSelectModal.allStationList = [];
        // 回显之前选择的站点
        this.stationSelectModal.selectedStations = this.formData.station_ids || [];
        
        // 获取壳牌中国站点列表
        try {
          //console.log('开始获取壳牌中国站点列表...');
          
          // 构建请求参数
          const params = {
            platforms: true,
            page: 1,
            pagesize: 1000
          };
          
          // 如果选择了省份，传递给后端
          if (this.formData.province) {
            params.province_name = this.formData.province;
          }
          
          // 如果选择了城市，传递给后端
          if (this.formData.city) {
            params.city_name = this.formData.city;
          }
          
          // 如果选择了油站类型，传递给后端
          if (this.formData.station_type) {
            params.station_type = this.formData.station_type;
          }
          
          let res = await this.$commonFun.postProxy('admin/gas/getSimpleStationList', params);
          
          //console.log('接口返回数据:', res);
          
          // 处理不同的返回数据结构
          let stations = [];
          if (res.data) {
            if (Array.isArray(res.data)) {
              stations = res.data;
            } else if (res.data.list && Array.isArray(res.data.list)) {
              stations = res.data.list;
            }
          }
          
          this.stationSelectModal.allStationList = stations;
          this.stationSelectModal.stationList = stations;
          console.log('获取到站点列表:', stations.length, '条');
          
        } catch (error) {
          console.error('获取站点列表失败:', error);
          this.$Message.error('获取站点列表失败：' + (error.message || '未知错误'));
        }
      },
      // 取消选择
      cancelStationSelect(){
        this.stationSelectModal.visible = false;
        // 不重置 selectedStations，因为可能已经保存到 formData
      },
      // 确认选择站点（只保存站点ID，不调用接口）
      submitStationPrice(){
        if (this.stationSelectModal.selectedStations.length === 0) {
          this.$Message.warning('请至少选择一个站点');
          return;
        }
        
        // 将选中的站点ID保存到 formData
        this.formData.station_ids = [...this.stationSelectModal.selectedStations];
        
        // 关闭弹窗
        this.stationSelectModal.visible = false;
        
        this.$Message.success(`已选择 ${this.formData.station_ids.length} 个站点`);
      },
      // 显示已选择的站点列表
      async showSelectedStations(row) {
        this.selectedStationsModal.currentRow = row;
        this.selectedStationsModal.visible = true;
        this.selectedStationsModal.stationList = [];
        
        //console.log('点击查看站点，row数据:', row);
        
        // 处理 station_ids，可能是字符串或数组
        let stationIdsStr = '';
        if (row.station_ids) {
          if (typeof row.station_ids === 'string') {
            stationIdsStr = row.station_ids;
          } else if (Array.isArray(row.station_ids)) {
            stationIdsStr = row.station_ids.join(',');
          }
        }
        
        console.log('stationIdsStr:', stationIdsStr);
        
        // 如果有站点ID，获取站点详细信息
        if (stationIdsStr) {
          try {
            console.log('开始请求接口...');
            let res = await this.$commonFun.postProxy('admin/gas/getSimpleStationList', {
              station_ids: stationIdsStr,
              page: 1,
              pagesize: 1000
            });
            
            console.log('接口返回数据:', res);
            
            let stations = [];
            if (res.data) {
              if (Array.isArray(res.data)) {
                stations = res.data;
              } else if (res.data.list && Array.isArray(res.data.list)) {
                stations = res.data.list;
              }
            }
            
            this.selectedStationsModal.stationList = stations;
            console.log('站点列表:', stations);
          } catch (error) {
            console.error('获取站点详情失败:', error);
            this.$Message.error('获取站点详情失败');
          }
        } else {
          console.log('没有站点ID');
        }
      },
      // 关闭已选择站点查看弹窗
      cancelSelectedStationsView() {
        this.selectedStationsModal.visible = false;
        this.selectedStationsModal.stationList = [];
        this.selectedStationsModal.currentRow = null;
      },
      // 全选站点
      selectAllStations() {
        const allIds = this.stationSelectModal.stationList.map(station => station.station_id);
        this.$set(this.stationSelectModal, 'selectedStations', allIds);
      },
      // 清空选择
      clearAllStations() {
        this.$set(this.stationSelectModal, 'selectedStations', []);
      }
    },
    mounted() {
      this.getInfo()
      this.init()
    },
  }
</script>

<style scoped>

</style>
